// extracted by mini-css-extract-plugin
export default {"title":"ReferralLandingPage_title__m2RW0","content":"ReferralLandingPage_content__7+pvj","bottomButtons":"ReferralLandingPage_bottomButtons__SNW4S"};